var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { addCommasWithConditionalDecimal, } from "@domains/utils/numberMethods";
import "@frameworks/shared-library/stylesheets/components/GenericDetails/GenericDetails.scss";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import { nanoid } from "nanoid";
export var EValueType;
(function (EValueType) {
    EValueType["TEXT"] = "text";
    EValueType["CURRENCY"] = "currency";
    EValueType["DATE_TIME"] = "date-time";
    EValueType["NUMBER"] = "number";
})(EValueType || (EValueType = {}));
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
/**
 * GenericDetailsTable
 *
 * This component gives you a tabular structure for any key-value pair passed in.
 * Provides optional Information icon to view more information about the content.
 * Provides a copy icon to copy that value to your clipboard.
 *
 * @param {Array<IGenericDetailsItem>} details - Table content
 * @param {string} header - Table header/title
 * @param {string} parentClassName - Any parent scss class to control stylings
 * @returns {}
 */
export var renderValue = function (type, value) {
    switch (type) {
        case EValueType.TEXT:
            return React.createElement("label", { className: "DMSans_13_400" }, value === null || value === void 0 ? void 0 : value.toString());
        case EValueType.NUMBER:
            return React.createElement("label", { className: "Roboto_13_400" }, value);
        case EValueType.CURRENCY:
            return (React.createElement("label", { className: "Roboto_13_400" }, "\u20B9 ".concat(addCommasWithConditionalDecimal(value === null || value === void 0 ? void 0 : value.toString()))));
        case EValueType.DATE_TIME:
            var date = new Date(value === null || value === void 0 ? void 0 : value.toString());
            if (date && isFinite(+date)) {
                var time = date.toLocaleTimeString();
                return (React.createElement("label", { className: "Roboto_13_400" }, "".concat(date.getDate(), " ").concat(months[date.getMonth()], " ").concat(date.getFullYear(), ", ").concat(time)));
            }
            else {
                return "_";
            }
        default:
            return React.createElement("label", { className: "DMSans_13_400" }, value);
    }
};
var GenericDetails = function (props) {
    var _a = __read(useState([]), 2), details = _a[0], setDetails = _a[1];
    var _b = __read(useState(false), 2), showCopyTooltip = _b[0], setShowCopyTooltip = _b[1];
    var uniqueIdForTableDetailsContainer = nanoid();
    var uniqueIdForValueContainer = nanoid();
    var copyContent = function (value) {
        setShowCopyTooltip(true);
        navigator.clipboard.writeText(value);
        setTimeout(function () {
            setShowCopyTooltip(false);
        }, 1000);
    };
    var renderDetailsRow = function (rowItem) {
        return rowItem ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex flex-row justify-content-between align-items-start details-row", key: nanoid() },
                React.createElement("div", { className: "d-flex flex-row details-label-box align-items-center gap-1", id: uniqueIdForTableDetailsContainer },
                    React.createElement("label", { className: "DMsanL_12_300" }, rowItem.label),
                    rowItem.tooltipText ? (React.createElement(GenericTooltip, { container: function () {
                            return document.getElementById(uniqueIdForTableDetailsContainer);
                        }, toolTipClassName: "", placement: "top", triggerType: "hover", externalClassName: "remove-btn-props", toolTipText: rowItem.tooltipText, button: React.createElement("i", { className: "edel-icon-Information" }) })) : (""),
                    rowItem.labelSuffix ? (React.createElement("label", { className: "DMSansNormal_12_400 label-suffix" }, rowItem.labelSuffix)) : ("")),
                React.createElement("div", { className: "d-flex flex-row justify-content-end details-value-box", id: uniqueIdForValueContainer },
                    (rowItem === null || rowItem === void 0 ? void 0 : rowItem.valueIcon) ? (typeof rowItem.valueIcon === "string" ? (React.createElement("i", { className: rowItem.valueIcon })) : (rowItem.valueIcon)) : (""),
                    renderValue(rowItem.valueType, rowItem.value),
                    rowItem.copyValue ? (React.createElement(GenericTooltip, { container: function () {
                            return document.getElementById(uniqueIdForValueContainer);
                        }, toolTipClassName: "", placement: "top", triggerType: "click", showTooltip: showCopyTooltip, hasOuterShowState: true, externalClassName: "remove-btn-props d-flex mgl-5 copy-value-tooltip", toolTipText: "Copied", button: React.createElement("i", { className: "edel-icon-duplicate-1", onClick: function () { var _a; return copyContent((_a = rowItem.value) === null || _a === void 0 ? void 0 : _a.toString()); } }) })) : (""))),
            React.createElement("hr", null))) : ("");
    };
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.details) {
            setDetails(props.details);
        }
    }, [props.details]);
    return (React.createElement("div", { className: "d-flex flex-column details-table ".concat((props === null || props === void 0 ? void 0 : props.parentClassName) ? props.parentClassName : "") },
        props.header ? (React.createElement("label", { className: "DMSanM_13_500" }, props.header)) : (""),
        (details === null || details === void 0 ? void 0 : details.length) > 0 && (React.createElement("div", { className: "details-row-box" }, details.map(function (item) {
            {
                return renderDetailsRow(item);
            }
        })))));
};
export default GenericDetails;
